import type { FieldConfiguration } from "../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureUnit, ReportField } from "../../../../../../../api/types/svTypes.ts";
import { isAggregation, isCustomColumn, isIrr, isMeasure } from "../../../utilities/fieldsHelper.ts";
import { getMeasureAmountTypeField, getMeasureCalculateByField } from "../../../utilities/isConfigurationValid.ts";

const getTrackedMeasureProperties = (fields: ReportField[]): MeasureInfoTracked[] => {
  return fields.map((measure) => {
    const field: MeasureInfoTracked = {
      guid: measure.config.guid,
      dateRange: measure.config.dateRange,
      standalone: measure.config.standalone,
      calculateByField: getMeasureCalculateByField(measure),
      blankZero: measure.config.blankZero,
      reverseSign: measure.config.reverseSign,
      customLabel: measure.config.customLabel,
      format: measure.config.format,
      hideBlankValues: measure.config.hideBlankValues,
      hideZeroValues: measure.config.hideZeroValues,
      customId: measure.config.customId,
      postConditions: measure.config.postConditions,
    };

    if (isMeasure(measure)) {
      field.units = measure.meta.units;
      field.amountType = getMeasureAmountTypeField(measure);
    }

    if (isIrr(measure)) {
      field.cashFlowFrequency = measure.config.cashFlowFrequency;
      field.periodDateField = measure.config.periodDateField;
    }

    if (isAggregation(measure)) {
      field.aggregation = measure.config.aggregation;
    }

    if (isCustomColumn(measure)) {
      field.calculationType = measure.config.calculationType;
      field.formulaParameters = measure.config.formulaParameters;
      field.formula = measure.config.formula;
      field.blankIfMissingValue = measure.config.blankIfMissingValue;
    }

    return field;
  });
};

export type MeasureInfoTracked = Pick<
  FieldConfiguration,
  | "guid"
  | "dateRange"
  | "standalone"
  | "calculateByField"
  | "blankZero"
  | "reverseSign"
  | "customLabel"
  | "format"
  | "hideBlankValues"
  | "hideZeroValues"
  | "cashFlowFrequency"
  | "periodDateField"
  | "amountType"
  | "aggregation"
  | "customId"
  | "postConditions"
  | "calculationType"
  | "formulaParameters"
  | "formula"
  | "blankIfMissingValue"
> & {
  units?:
    | {
        [key: string]: MeasureUnit;
      }
    | undefined
    | null;
};

export default getTrackedMeasureProperties;
